import { theme } from '@jadwalh/ui';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const suggestion = ({
  items,
  command,
  clientRect,
}: {
  items: any[];
  command: (item: any) => void;
  clientRect: () => DOMRect;
}) => {
  let popup: any = null;
  let selectedIndex = 0;

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) {
      command(item);
    }
  };

  const upHandler = () => {
    selectedIndex = (selectedIndex + items.length - 1) % items.length;
    updateList();
  };

  const downHandler = () => {
    selectedIndex = (selectedIndex + 1) % items.length;
    updateList();
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  const updateList = () => {
    const element = popup?.[0]?.popper?.querySelector('.mentions-list');
    if (!element) return;

    const items = element.querySelectorAll('.mention-item');
    items.forEach((item: Element, index: number) => {
      if (index === selectedIndex) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
    });
  };

  const createPopup = () => {
    popup = tippy('body', {
      getReferenceClientRect: clientRect,
      appendTo: () => document.body,
      content: renderItems(),
      showOnCreate: true,
      interactive: true,
      trigger: 'manual',
      placement: 'bottom-start',
      theme: 'custom',
      onCreate(instance) {
        const content = instance.popper.querySelector('.tippy-content');
        if (content instanceof HTMLElement) {
          content.style.cssText = `
          background-color: #ffffff;
          padding: 0;
          border: 1px solid ${theme.colours.newOutline} !important;
          border-radius: 8px !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          `;
        }
      },
    });
  };

  const renderItems = () => {
    const element = document.createElement('div');
    element.classList.add('mentions-list');
    element.style.cssText = `
      display: flex !important;
      flex-direction: column !important;
      gap: 4px !important;
      padding: 8px !important;
      border-radius: 8px !important;
    `;

    if (items.length === 0) {
      const noResults = document.createElement('div');
      noResults.style.cssText = `
        padding: 8px 12px !important;
        color: #6B7280 !important;
        font-size: 14px !important;
        text-align: center !important;
        border-radius: 8px !important;
      `;
      noResults.textContent = 'No matches found';
      element.appendChild(noResults);
      return element;
    }

    items.forEach((item, index) => {
      const button = document.createElement('button');
      button.classList.add('mention-item');
      button.style.cssText = `
        width: auto !important;
        border: none !important;
        background: none !important;
        padding: 4px 8px !important;
        cursor: pointer !important;
        text-align: left !important;
        display: flex !important;
        align-items: center !important;
      `;

      button.addEventListener('mouseenter', () => {
        if (!button.classList.contains('selected')) {
          button.style.backgroundColor =
            theme.colours.newOutline + ' !important';
        }
      });

      button.addEventListener('mouseleave', () => {
        if (!button.classList.contains('selected')) {
          button.style.backgroundColor = 'transparent !important';
        }
      });

      if (index === selectedIndex) {
        button.classList.add('selected');
        button.style.backgroundColor = `${theme.colours.newOutline} !important`;
      }

      const contentWrapper = document.createElement('div');
      contentWrapper.style.cssText = `
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
      `;

      const text = document.createElement('span');
      text.textContent = item.display;

      contentWrapper.appendChild(text);
      button.appendChild(contentWrapper);

      button.addEventListener('click', () => {
        command(item);
        popup?.[0]?.destroy();
      });
      element.appendChild(button);
    });

    return element;
  };

  const updateProps = (props: any) => {
    popup?.[0]?.setProps({
      getReferenceClientRect: props.clientRect,
    });
    popup?.[0]?.setContent(renderItems());
  };

  const onKeyDown = ({ event }: { event: KeyboardEvent }) => {
    if (event.key === 'ArrowUp') {
      upHandler();
      return true;
    }

    if (event.key === 'ArrowDown') {
      downHandler();
      return true;
    }

    if (event.key === 'Enter' || event.key === 'Tab') {
      enterHandler();
      return true;
    }

    return false;
  };

  const destroy = () => {
    if (popup?.[0]) {
      popup[0].destroy();
      popup = null;
    }
  };

  createPopup();

  return {
    onKeyDown,
    updateProps,
    destroy,
  };
};

export default suggestion;
